/**
 * MGT-012 passenger archetypes (alpha), derived from the serial so nothing new is stored. Act I keeps plain travellers
 * (VIPs excepted). Each type has a visible tell, one simulated effect and a player lever.
 *   business: twice the desk handling time, patience runs out faster (0.6x), pays double at Check-In (lever: speed/staff)
 *   family:   checks two bags at Bag Drop (lever: handlers/belt)
 *   vip:      pays double everywhere and prefers a staffed lounge (existing)
 * International travellers (Passport) are orthogonal; see config.internationalTraveller.
 */
export type Archetype = 'vip' | 'business' | 'family' | 'pet' | 'economy';
export function archetype(serial: number, vip: boolean, act2: boolean): Archetype {
    if (vip) return 'vip';
    if (!act2) return 'economy';
    return serial % 5 === 1 ? 'business' : serial % 7 === 3 ? 'family' : serial % 11 === 4 ? 'pet' : 'economy';
}
/** TX-028: a traveller with a pet calms their line: everyone queued at that desk loses patience 20% slower. */
export const PET_CALM = 0.8;
export const BUSINESS_HANDLING = 2, BUSINESS_PATIENCE = 0.6, BUSINESS_FARE = 2, FAMILY_BAGS = 2;
/** Extra bags carry the owner's serial plus this offset (bag serials are unique); owner = serial % BAG_SERIAL_SPAN. */
export const BAG_SERIAL_SPAN = 1_000_000_000;
export function bagSerial(owner: number, index: number): number { return owner + index * BAG_SERIAL_SPAN; }
export function bagOwner(serial: number): number { return serial % BAG_SERIAL_SPAN; }

/**
 * MGT-023 connecting passengers at Metro: one in four arrivals stays airside and heads straight for the gates with a
 * deadline. Their serial is offset by CONNECT_SPAN (unique, and marks them as connectors without a stored flag).
 */
export const CONNECT_SPAN = 2_000_000_000, CONNECT_DEADLINE = 900;
export function connectsHere(serial: number, airportCode: string, act2: boolean): boolean { return act2 && airportCode === 'MTR' && serial % 4 === 0; }
export function isConnector(serial: number): boolean { return serial >= CONNECT_SPAN; }
